module.exports = __webpack_public_path__ + "img/MONEY.f2003510.svg";